import {ReactElement} from "react";
import VZAlert from "../../vz-ui/vz-alert/VZAlert";
import * as css from "../styles/revenue-wizard.module.scss";


interface IIntroProps {
    propertyName: string;
    budgetYear: number;
}

export default function Intro({propertyName, budgetYear}: IIntroProps): ReactElement {
    return (
        <div className={css.introWrapper}>
            <h3 className={css.stepTitle}>How it Works</h3>

            <div className={css.introBody}>
                <p className={css.stepParagraph}>The <span className={css.boldText}>Revenue Wizard</span> can help provide starting values for a fresh budget.</p>
                <p className={css.stepParagraph}>On the following screens, we'll ask for Expirations, Target Average Occupancy Rate, Target Average Renewal Rate, and if you prefer rates that only give you metrics with whole unit counts.</p>
                <p className={css.stepParagraph}>We'll then use these to generate a set of values for each Unit Type, each metric, and each month by adhering as closely as we can to your targets while avoiding issues like Negative Move Ins and respecting your unit rounding preferences.</p>
            </div>

            <VZAlert
                alertType={"warning"}
                title={"Before You Continue"}
                message={`Completing the Revenue Wizard will overwrite all Expirations, Occupancy Rates, Renewal Rates, and Move Out Rates entered for your Reforecast ${budgetYear - 1} and Budget ${budgetYear} seasons for ${propertyName}.`}
            />
        </div>
    );
}
